import { Layout } from 'antd';
import React, { useContext, useMemo, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Context } from '../../../index';
import Header from '../Header/Header';
import ChatsIcon from '../Icon-SVG/ChatsIcon';
import Exit from '../Icon-SVG/Exit';
import ProfileIcon from '../Icon-SVG/ProfileIcon';
import SupportIcon from '../Icon-SVG/SupportIcon';

const { Sider, Content } = Layout;

const StyledParagraph = styled.p`
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
  color: #a6b0cf;
  margin: 0;
`;

const Logo = styled.img`
  width: 48px;
  height: 48px;
  margin: 16px;
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const MenuLink = styled(Link)`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const MenuItem = styled.div`
  height: 45px;
  width: 45px;
  padding: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 24px;
`;

const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const MainContentChildrenWrapper = styled.div`
  display: flex;
  margin-left: 80px;
`;

const ViewPort = styled.div`
  height: 100vh;
`;

const MainSider = styled(Sider)`
  height: 100vh;
  position: fixed;
  left: 0;
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.08);
  background: #fff;
`;

const Sidebar = ({ children }) => {
  const history = useHistory();
  const { auth } = useContext(Context);
  const [user] = useAuthState(auth);
  const { pathname } = history.location;
  const [search, setSearch] = useState(false);

  const header = useMemo(() => {
    if (pathname === '/profile') return 'Profile';
    if (pathname === '/rooms' || pathname === '/chat') return 'Chat';
    if (pathname === '/search') return 'Search';
    if (pathname === '/support') return 'Support';
    return 'Skylex';
  }, [pathname]);

  const renderMenu = () => (
    <Menu>
      <Link to="/">
        {/* eslint-disable-next-line @typescript-eslint/no-var-requires */}
        <Logo src={require('../Icon-SVG/Logo.svg').default} alt="logo" />
      </Link>
      <MenuItem key="/rooms">
        <MenuLink to="/rooms">
          <ChatsIcon
            color={pathname === '/rooms' || pathname === '/search' ? '#397EF3' : '#A6B0CF'}
          />
          <StyledParagraph
            style={{
              color: pathname === '/rooms' || pathname === '/search' ? '#397EF3' : '#A6B0CF',
            }}
          >
            Chats
          </StyledParagraph>
        </MenuLink>
      </MenuItem>
      <MenuItem key="/support">
        <MenuLink to="/support">
          <SupportIcon color={pathname === '/support' ? '#397EF3' : '#A6B0CF'} />
          <StyledParagraph style={{ color: pathname === '/support' ? '#397EF3' : '#A6B0CF' }}>
            Support
          </StyledParagraph>
        </MenuLink>
      </MenuItem>
      <MenuItem key="/profile">
        <MenuLink to="/profile">
          <ProfileIcon color={pathname === '/profile' ? '#397EF3' : '#A6B0CF'} />
          <StyledParagraph style={{ color: pathname === '/profile' ? '#397EF3' : '#A6B0CF' }}>
            Profile
          </StyledParagraph>
        </MenuLink>
      </MenuItem>
    </Menu>
  );

  const isWithLayout = pathname !== '/' && user;
  const isChat = pathname.indexOf('/rooms') > -1;

  return isWithLayout ? (
    <Layout>
      <MainSider width={80} breakpoint="lg">
        <MenuContent>
          {renderMenu()}
          <Exit />
        </MenuContent>
      </MainSider>
      <Content>
        <ViewPort>
          {!isChat && <Header search={search} setSearch={setSearch} name={header} />}
          <MainContentChildrenWrapper style={{ height: isChat ? '100vh' : 'calc(100vh - 64px)' }}>
            {children}
          </MainContentChildrenWrapper>
        </ViewPort>
      </Content>
    </Layout>
  ) : (
    children
  );
};
export default Sidebar;
